document.addEventListener("DOMContentLoaded", function () {
  var containers = document.querySelectorAll(
    ".mega-menu__details-subwrapper, .mega-menu__details-subwrapper--fixed"
  );

  containers.forEach(function (container) {
    container.addEventListener("wheel", function (event) {
      if (event.deltaY !== 0) {
        // checks if the scroll was vertical with a mouse wheel
        event.preventDefault();
        container.scrollBy({
          left: event.deltaY, // converts vertical scroll into horizontal movement
          behavior: "smooth",
        });
      }
    });
  });
});
